export default function PageSection({ sectionName, isForm = false, children }) {
  return (
    <div className="page-section">
      <p className="display-4">{sectionName}</p>
      <div className={isForm ? "page-section-wrapper" : ""}>
        {children || null}
      </div>
    </div>
  );
}
